/**
 * SessionStorage key and helpers for the "presupuesto/pedido desde productos" basket.
 * Used when redirecting from ProductoList to the create presupuesto/pedido page.
 */
export const PRESUPUESTO_PEDIDO_BASKET_KEY = "presupuestoPedidoBasket";

export function getBasketFromStorage() {
  try {
    const raw = sessionStorage.getItem(PRESUPUESTO_PEDIDO_BASKET_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function setBasketInStorage(items) {
  try {
    sessionStorage.setItem(PRESUPUESTO_PEDIDO_BASKET_KEY, JSON.stringify(items || []));
  } catch (e) {
    console.error("setBasketInStorage", e);
  }
}

export function clearBasketStorage() {
  try {
    sessionStorage.removeItem(PRESUPUESTO_PEDIDO_BASKET_KEY);
  } catch (e) {
    console.error("clearBasketStorage", e);
  }
}
